import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';


const validate = values => {
    const errors = {}

    if (!values.year) {
        errors.year = 'Required'
    }

    if (!values.cvc) {
        errors.cvc = 'Required'
    }

    if (!values.month) {
        errors.month = 'Required'
    }

    if (!values.cardnumber) {
        errors.cardnumber = 'Required'
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const select = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)



class BillingInformation extends React.Component {

    years() {
        let years = [];
        const today = new Date().getFullYear();
        for(let i = today; i<=(parseInt(today)+10);i++) {
            years.push({
                'value':i,
                'label':i
            });
        }
        return years;
    }

    month() {
        let month = [];

        for(let i = 1; i<=12;i++) {
            month.push({
                'value':i,
                'label':i
            });
        }
        return month;
    }


    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6 offset-sm-3">
                        <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                            <div className="panel-heading">
                                <h3 className="panel-title">Payment</h3>
                            </div>
                            <div className="panel-body">

                            {this.props.errorMessage !== false ?
                            <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                            <i className="icon wb-close" aria-hidden="true"></i>
                            {this.props.errorMessage}
                            </div>
                            :null}

                            <div className="row">
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" name="cardnumber" placeholder="123412341234" title="Credit card number" className="form-control" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-4">
                                    <Field component={select} options={this.month()} name="month" title="Expiry month" />
                                </div>

                                <div className="col-sm-4">
                                    <Field component={select} options={this.years()} name="year"  title="Expiry year" />
                                </div>

                                <div className="col-sm-4">
                                    <Field component={renderField} type="text" name="cvc" placeholder="123" title="CVC" className="form-control" />
                                </div>
                            </div>

                            <div className="row m-t-20">
                                <div className="col-sm-12">
                                    {
                                        this.props.isWaiting
                                        ?
                                        <LoadingSmall />
                                        :
                                        <button type="submit" className="btn btn-dark btn-block">
                                            {
                                                this.props.buttonText ?
                                                    this.props.buttonText:'Confirm payment'
                                            }
                                        </button>
                                    }
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});


// Decorate the form component
BillingInformation = reduxForm({
  form: 'BillingInformation',
  validate,
})(BillingInformation);

BillingInformation = connect(
  state => ({
    initialValues: {
        year: new Date().getFullYear(),
        month:new Date().getMonth(),
      }
  })
)(BillingInformation)

export default BillingInformation;



// WEBPACK FOOTER //
// ./containers/settings/form/Card.js